// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const clodsire: PokeData = {
  "id": 980,
  "name": "clodsire",
  "height": 18,
  "weight": 2230,
  "base_experience": 151,
  "types": [
    PokeType.POISON,
    PokeType.GROUND
  ],
  "api_moves": [
    "slam",
    "tail-whip",
    "poison-sting",
    "earthquake",
    "toxic",
    "amnesia",
    "megahorn",
    "yawn",
    "mud-shot",
    "poison-tail",
    "toxic-spikes",
    "poison-jab",
    "sludge-wave"
  ],
  "moves": [
    "earthquake",
    "mud-shot",
    "toxic-spikes",
    "poison-jab",
    "toxic-overload",
    "rototiller",
    "venom-drench",
    "acid",
    "mortal-gas",
    "poison-gas",
    "sandstorm",
    "poison-fang",
    "stun-spore"
  ],
  "evolution_chain": {
    "id": 96,
    "item": null,
    "species": [
      {
        "name": "wooper",
        "order": 225,
        "types": [
          PokeType.WATER,
          PokeType.GROUND
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      },
      {
        "name": "quagsire",
        "order": 226,
        "types": [
          PokeType.WATER,
          PokeType.GROUND
        ],
        "evolves_from_species_id": 194,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": 20,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      },
      {
        "name": "clodsire",
        "order": 1009,
        "types": [
          PokeType.POISON,
          PokeType.GROUND
        ],
        "evolves_from_species_id": 194,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": 20,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      }
    ]
  },
  "stats": {
    "resistance": 210,
    "speed": 40,
    "ability_power": 150
  },
  "stat_changes": [],
  "catch_rate": 90,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
